import {useState} from 'react'
import AddNomineeModal from './add-nominee-modal'
import {useIntl} from 'react-intl'
import Skeleton from 'react-loading-skeleton'

export const IndividualNominee = ({
  shareholderBankDetails,
  fetchBankDetails,
  shareholderBankDetailsLoading,
}: {
  shareholderBankDetails: any
  fetchBankDetails: () => void
  shareholderBankDetailsLoading: boolean
}) => {
  const {formatMessage} = useIntl()
  const [isActive, setIsActive] = useState(false)

  return (
    <>
      <div className='bg-white rounded-2 px-md-4 px-2 py-4 position-relative mb-4'>
        <div className='d-md-flex justify-content-between w-100 align-items-center mb-4'>
          <h2 className='font-size-16'>{formatMessage({id: 'Nominee Details'})}</h2>
          <button
            className='btn btn-primary justify-content-center text-mute font-weight-400 font-size-13 height-36 d-flex align-items-center w-100 w-md-auto'
            onClick={()=>setIsActive(true)}
          >
            {formatMessage({id: 'Edit Nominee'})}
          </button>
        </div>

        <div className='row gx-8 justify-content-between'>
          <div className='col-md-6'>
            <div className='mb-4 d-flex gap-2 align-items-center'>
              <p className='text muted font-size-12 mb-0 min-w-200px min-w-md-200px'>
                {formatMessage({id: 'First Name'})}
              </p>
              {shareholderBankDetailsLoading ? (
                <Skeleton
                  height={20}
                  width={190}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-13 mb-0'>{shareholderBankDetails?.nominee?.firstName || "-"}</p>
              )}
            </div>
            <div className='mb-4 d-flex gap-2 align-items-center'>
              <p className='text muted font-size-12 mb-0 min-w-200px min-w-md-200px'>
                {formatMessage({id: 'Last Name'})}
              </p>
              {shareholderBankDetailsLoading ? (
                <Skeleton
                  height={20}
                  width={190}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-13 mb-0'>{shareholderBankDetails?.nominee?.lastName || "-"}</p>
              )}
            </div>
            <div className='mb-4 d-flex gap-2 align-items-center'>
              <p className='text muted font-size-12 mb-0 min-w-200px min-w-md-200px'>
                {formatMessage({id: 'Relationship'})}
              </p>
              {shareholderBankDetailsLoading ? (
                <Skeleton
                  height={20}
                  width={190}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-13 mb-0'>{shareholderBankDetails?.nominee?.relationship || "-"}</p>
              )}
            </div>
            <div className='mb-4 d-flex gap-2 align-items-center'>
              <p className='text muted font-size-12 mb-0 min-w-200px min-w-md-200px'>
                {formatMessage({id: 'Date of Birth'})}
              </p>
              {shareholderBankDetailsLoading ? (
                <Skeleton
                  height={20}
                  width={190}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-13 mb-0'>{shareholderBankDetails?.nominee?.dateOfBirth || "-"}</p>
              )}
            </div>
          </div>

          <div className='col-md-6'>
            <div className='mb-4 d-flex gap-2 align-items-center'>
              <p className='text muted font-size-12 mb-0 min-w-200px min-w-md-200px'>
                {formatMessage({id: 'Mobile'})}
              </p>
              {shareholderBankDetailsLoading ? (
                <Skeleton
                  height={20}
                  width={190}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-13 mb-0'>{shareholderBankDetails?.nominee?.mobileNumber || "-"}</p>
              )}
            </div>
            <div className='mb-4 d-flex gap-2 align-items-center'>
              <p className='text muted font-size-12 mb-0 min-w-200px min-w-md-200px'>
                {formatMessage({id: 'Email'})}
              </p>
              {shareholderBankDetailsLoading ? (
                <Skeleton
                  height={20}
                  width={190}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-13 mb-0'>{shareholderBankDetails?.nominee?.email|| "-"}</p>
              )}
            </div>
            <div className='mb-4 d-flex gap-2 align-items-center'>
              <p className='text muted font-size-12 mb-0 min-w-200px min-w-md-200px'>
                {formatMessage({id: 'Address'})}
              </p>
              {shareholderBankDetailsLoading ? (
                <Skeleton
                  height={20}
                  width={190}
                  baseColor='var(--kt-skeleton-bg-color)' 
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-13 mb-0'>{shareholderBankDetails?.nominee?.address || "-"}</p>
              )}
            </div>
          </div>
        </div>
        <AddNomineeModal
          isActive={isActive}
          setIsActive={setIsActive}
          shareholderBankDetails={shareholderBankDetails}
          fetchBankDetails={fetchBankDetails}
         
        />
      </div>
    </>
  )
}
